export const setStep9Page = setPage => page => dispatch => {
  dispatch({
    type: setPage,
    payload: {page}
  });
};
